import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'retired-css-invoice-header',
  templateUrl: './retired-css.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./retired-css.css']
})
export class RetiredCssInvoiceHeaderComponent {}
